// extracted by mini-css-extract-plugin
module.exports = {"navItem":"NavigationItem_navItem__2RNig","active":"NavigationItem_active__2MiNG"};